import { render, staticRenderFns } from "./HeaderComponent.vue?vue&type=template&id=2725ca82&scoped=true"
import script from "./HeaderComponent.vue?vue&type=script&lang=ts"
export * from "./HeaderComponent.vue?vue&type=script&lang=ts"
import style0 from "./HeaderComponent.vue?vue&type=style&index=0&id=2725ca82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2725ca82",
  null
  
)

export default component.exports